import React from "react";
import Icons from "../../Icons";

const UIInput = ({
    name,
    type,
    labelClassName,
    label,
    placeholder,
    required,
    value,
    isPasswordType,
    isPasswordVisible,
    error,
    errorName,
    onChange,
    onClickInputButton,
    props,
}) => {
    return (
        <div className={`ui-input-component ${error ? 'field-error' : ''}`}>
            {!!label && (
                <label
                    htmlFor={name}
                    className={labelClassName}
                >
                    {label}
                </label>
            )}
            {error && errorName && 
                <label className="input-error">{errorName}</label>
            }
            {error && typeof error === 'string' &&
                <label className="input-error">{error}</label>
            }
            <input
                type={type}
                name={name}
                value={value || ''}
                onInput={(e) => onChange(e.target.value)}
                required={required}
                placeholder={placeholder}
                className={error ? 'input-error' : ''}
                {...props}
            />
            {(errorName && !isPasswordType) && (
                <button
                    className="field-button"
                    onClick={() => onChange('')}
                >
                    <Icons name="close" />
                </button>
            )}
            {isPasswordType && (
                <button
                    type="button"
                    className="field-button"
                    onClick={onClickInputButton}
                >
                    {isPasswordVisible
                        ? <Icons name="eye" />
                        : <Icons name="eye_closed" />
                    }
                </button>
            )}
        </div>
    );
};

export default UIInput;
